
//门店名称 联系人 联系电话 公司地址 有效期
const columnList: Array<any> = [
        {
            prop: "repair_unit_name",
            label: "送修单位名称",
            width: 200,
        },
    {
        prop: "repair_unit_contacts",
        label: "联系人",
        width: 200,
    },
    {
        prop: "repair_unit_phone",
        label: "联系电话",
        width: 200,
    },
    {
        prop: "repair_unit_address",
        label: "地址",
        width: 200,
    }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch
} from "vue";
import { useRoute, useRouter } from 'vue-router'
import {getframeworkList, getRepairUnitList, permissionList} from "@/api/http";
import {column} from "@/assets/types/common";
import axios from "axios";
import { Request } from "@/api/request";


export default defineComponent({
    name: "repaircompany",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["送修单位"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            dialog_model = ref(""),
            formRef = ref(null),
            form = ref({} as any),
            dialog_index = ref(0),
            screenParameter = reactive({
                page: currentPage.value,
                pagesize: pageSize.value,
                search:''
            }),
            // 切换每页数量大小
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            // 切换分页
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'repair_company',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                screenParameter['page'] = currentPage.value
                screenParameter['pagesize'] = pageSize.value
                getRepairUnitList({...screenParameter}).then((res:any)=>{
                    tableData.value = res?.content?.list || [];
                    total.value = res.content.total;
                    loading.value = false;
                });
            },
            _upState =(id: number, status: number) => {
                Request.axiosInstance({
                    url:　'adminapi/RepairUnit/upState',
                    data: {
                        repair_unit_id: id,
                        status:status
                    }
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                });
            },
            resetTableData = (()=>{
                currentPage.value = 1;
                getTableData();
            }) ,
            selectChange = (e: any, key: string): void => {
                resetTableData();
            },
            _submitForm = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return
                    Request.axiosInstance({
                        url:  dialog_model.value == 'edit' ? 'adminapi/RepairUnit/edit' :  'adminapi/RepairUnit/create' ,
                        data: form.value
                    }).then((res: any) => {
                        res.status == 202 && (getTableData(), dialog_model.value ='')
                    })
                })
            }
        
        
        
        onMounted(() => {
            
            
            
            
            
            getTableData()
        });
        
        
        watch(dialog_model, (newval, oldval) => {
            if (formRef.value){
                (formRef.value as any).resetFields();
            }
            if(newval == 'add')
            {
                form.value ={
                    repair_unit_name: '',
                    repair_unit_contacts: '',
                    repair_unit_phone: '',
                    repair_unit_mail: '',
                    repair_unit_address: '',
                    repair_unit_comment: '',
                }
                
            }
            else if(newval == 'edit')
            {
                form.value ={
                    repair_unit_id:tableData.value[dialog_index.value].repair_unit_id,
                    repair_unit_name: tableData.value[dialog_index.value].repair_unit_name,
                    repair_unit_contacts: tableData.value[dialog_index.value].repair_unit_contacts,
                    repair_unit_phone: tableData.value[dialog_index.value].repair_unit_phone,
                    repair_unit_mail: tableData.value[dialog_index.value].repair_unit_mail,
                    repair_unit_address: tableData.value[dialog_index.value].repair_unit_address,
                    repair_unit_comment: tableData.value[dialog_index.value].repair_unit_comment,
                }
            }
        })
        
        return {
            columnList,
            tableData,
            loading,
            headClass,
            screenParameter,
            _upState,
            dialog_model,
            dialog_index,
            form,
            formRef,
            _submitForm,
            roleList,
            handleCurrentChange,
            handleSizeChange,
            currentPage,
            pageSize,
            total,
            resetTableData,
            selectChange
        };
    },
});

